import { useState } from 'react';
import { Alert, Chip } from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';
import AdminUserAssignmentDialog from './components/AdminUserAssignmentDialog';

const AdminRolesPage = () => {
  const [assignmentTarget, setAssignmentTarget] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const columns = [
    { key: 'name', label: 'Role' },
    { key: 'description', label: 'Description' },
    { key: 'assigned_users_count', label: 'Assigned Users' },
    {
      key: 'is_active',
      label: 'Status',
      render: (row) =>
        row.is_active ? (
          <Chip size="small" label="Active" sx={{ bgcolor: 'rgba(22,163,74,0.12)', color: '#166534', fontWeight: 600 }} />
        ) : (
          <Chip size="small" label="Inactive" sx={{ bgcolor: 'rgba(220,38,38,0.12)', color: '#991b1b', fontWeight: 600 }} />
        )
    }
  ];

  const fields = [
    { name: 'name', label: 'Role Name', type: 'text', grid: 6 },
    { name: 'is_active', label: 'Active', type: 'switch', grid: 3, defaultValue: true },
    { name: 'is_system', label: 'System Role', type: 'switch', grid: 3, defaultValue: false },
    { name: 'description', label: 'Description', type: 'multiline', grid: 12 },
    { name: 'permissions', label: 'Permissions (JSON list)', type: 'json', grid: 12, defaultJson: [] }
  ];

  const rowActions = [
    {
      label: 'Assign Users',
      icon: GroupAddIcon,
      onClick: async (row) => {
        setAssignmentTarget(row);
      }
    }
  ];

  return (
    <>
      <Alert severity="info" sx={{ mb: 2 }}>
        Roles and their permissions are saved for your records and reporting. What a person can do on the platform is controlled by the User and Admin
        account type, which you set on the Users page.
      </Alert>
      <AdminResourceCrudPage
        title="Roles & Access"
        subtitle="Define custom platform roles and permission bundles."
        icon={BadgeIcon}
        endpoint="/api/admin/roles/"
        columns={columns}
        fields={fields}
        loadParams={{ refresh: refreshToken }}
        rowActions={rowActions}
      />
      <AdminUserAssignmentDialog
        open={Boolean(assignmentTarget)}
        endpoint={assignmentTarget ? `/api/admin/roles/${assignmentTarget.id}/assignments/` : ''}
        title={assignmentTarget ? `Role Assignments - ${assignmentTarget.name}` : 'Role Assignments'}
        subtitle="Select users who should have this role."
        onSaved={async () => setRefreshToken((prev) => prev + 1)}
        onClose={() => setAssignmentTarget(null)}
      />
    </>
  );
};

export default AdminRolesPage;
